"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var sha1_1 = __importDefault(require("crypto-js/sha1"));
var sha256_1 = __importDefault(require("crypto-js/sha256"));
var sha512_1 = __importDefault(require("crypto-js/sha512"));
var enc_base64_1 = __importDefault(require("crypto-js/enc-base64"));
var DigestAlgorithm;
(function (DigestAlgorithm) {
    DigestAlgorithm[DigestAlgorithm["SHA1"] = 0] = "SHA1";
    DigestAlgorithm[DigestAlgorithm["SHA256"] = 1] = "SHA256";
    DigestAlgorithm[DigestAlgorithm["SHA512"] = 2] = "SHA512";
})(DigestAlgorithm = exports.DigestAlgorithm || (exports.DigestAlgorithm = {}));
function HTTPDigestWithBase64(algo, plaintext) {
    var d = DigestWithBase64(algo, plaintext);
    var s = "";
    switch (algo) {
        case DigestAlgorithm.SHA1:
            s = "SHA-1";
            break;
        case DigestAlgorithm.SHA256:
            s = "SHA-256";
            break;
        case DigestAlgorithm.SHA512:
            s = "SHA-512";
            break;
    }
    return s + "=" + d;
}
exports.HTTPDigestWithBase64 = HTTPDigestWithBase64;
function DigestWithBase64(algo, plaintext) {
    switch (algo) {
        case DigestAlgorithm.SHA1:
            return enc_base64_1.default.stringify(sha1_1.default(plaintext));
        case DigestAlgorithm.SHA256:
            return enc_base64_1.default.stringify(sha256_1.default(plaintext));
        case DigestAlgorithm.SHA512:
            return enc_base64_1.default.stringify(sha512_1.default(plaintext));
    }
}
exports.DigestWithBase64 = DigestWithBase64;
